import React from "react";
import { List } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
const NavigationButton = ({ onClick }) => {
  const { i18n } = useTranslation();
  return (
    <div
      className={`relative overflow-hidden flex items-center justify-center  ${
        i18n.language === "ar" ? "ar" : "en"
      } custom-bg`}
    >
      <button
        onClick={onClick}
        className="relative flex flex-col items-center justify-center mx-auto w-32  text-white z-10 "
      >
        <List size={44} weight="light" />
      </button>
    </div>
  );
};

export default NavigationButton;
